/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createKeyResultRequestSchema = z.object({
  label: z.string(),
});
